import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import { IntlProvider } from 'dibs-react-intl';
import { Provider } from 'react-redux';
import serverVars from 'server-vars';
import * as tracking from 'dibs-tracking';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { SocketContextProvider } from 'dibs-subscriptions-utils/exports/SocketContext';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500';
import { ToastProvider } from 'dibs-toaster/exports/ToastProvider';

import { getEnvironment } from '../../relayModernEnvironment';
import CartLoading from '../../cart/CartLoading';
import { CartPageShimmer } from '../../multiItemCart/CartShimmers/CartPageShimmer';
import { CartServerVarsContextProvider } from '../../multiItemCart/CartServerVarsContext';
import { cartPageReducer } from '../../multiItemCart/cartPageReducer';

const root = createRoot(document.getElementById('js-root'), {
    identifierPrefix: 'abc',
});

const OldCart = lazy(() => import('../../cart/CartRenderer'));
const CartPage = lazy(() => import('../../multiItemCart/CartPage'));

const isMultiItemCart = serverVars.get('multiItemCartVariant');

const reducers = isMultiItemCart ? { cartPage: cartPageReducer } : {};

const { environment, socketListeners } = getEnvironment();

initializeDBL({ reducers }).then(({ store }) => {
    root.render(
        <Suspense fallback={<CartLoading isStaticLoading />}>
            <Provider store={store}>
                <IntlProvider
                    locale={serverVars.get('locale')}
                    messages={serverVars.get('messages')}
                >
                    <ToastProvider trackItemFavoriting>
                        {isMultiItemCart ? (
                            <SocketContextProvider socketListeners={socketListeners}>
                                <CartServerVarsContextProvider
                                    isMobile={serverVars.get('settings.isMobile')}
                                >
                                    <RelayEnvironmentProvider environment={environment}>
                                        <ErrorBoundary
                                            fallback={({ error }) => (
                                                <Error500Layout error={error} />
                                            )}
                                        >
                                            <Suspense
                                                fallback={
                                                    <CartPageShimmer
                                                        isMobile={serverVars.get(
                                                            'settings.isMobile'
                                                        )}
                                                    />
                                                }
                                            >
                                                <CartPage />
                                            </Suspense>
                                        </ErrorBoundary>
                                    </RelayEnvironmentProvider>
                                </CartServerVarsContextProvider>
                            </SocketContextProvider>
                        ) : (
                            <Suspense fallback={<CartLoading isStaticLoading />}>
                                <OldCart relayEnvironment={environment} />
                            </Suspense>
                        )}
                    </ToastProvider>
                </IntlProvider>
            </Provider>
        </Suspense>
    );
    tracking.trackPageview({
        url: window.location.pathname + window.location.search + window.location.hash,
        additional: serverVars.get('tracking.initialDataLayerInfo'),
    });
});
